import { MaterialService } from './../../service/material.service';
import { empty } from 'rxjs';
import { KiwixiService } from './../../kiwixi/kiwixi.service';
import { Component, Input, ViewChild, ViewContainerRef, OnChanges, ComponentFactoryResolver, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit, OnChanges, OnDestroy {
  @Input() componentToLoad: ComponentType<any>;
  @Input() componentName;
  @Input() modalParams;
  @Input() allowClose;
  @Output() emitEvent = new EventEmitter();
  @ViewChild('modalcontainer', { read: ViewContainerRef, static: true }) entry: ViewContainerRef;
  overlay
  element;
  // Généré avant le premier rendu pour que l'id soit présent dès la première détection de changements
  randomId: number = Math.floor(Math.random() * 10000) + 1;
  private closedEmitted = false; // évite double émission

  constructor(
    public viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    private kiwixiService: KiwixiService,
    private materialService: MaterialService,
  ) { }

  ngOnInit() {
    this.entry.clear();
  }

  ngOnChanges() {
    // Tente de récupérer l'élément; si pas encore rendu (cycle initial), on retente dans un micro-task
    this.element = document.getElementById('basemodal-' + this.randomId)
    if (!this.element) {
      setTimeout(() => this.ngOnChanges(), 0);
      return;
    }
    if (this.componentToLoad) {
      const factory = this.resolver.resolveComponentFactory(this.componentToLoad);
      this.overlay = this.entry.createComponent(factory);

        switch (this.componentName) {
          case 'TeacherProfilComponent': {
            this.overlay.instance.teacher = this.modalParams.teacher;
            this.overlay.instance.showReviews = this.modalParams.showReviews;
            break;
          }
          case 'InitPonctualBookingConclusionComponent': {
            this.overlay.instance.classCreated = this.modalParams.classCreated;
            this.overlay.instance.mode_formation = this.modalParams.mode_formation;
            this.overlay.instance.showDemoEmiter.subscribe(event => {
              this.emitEvent.emit()
              this.close();
            });
            break;
          }
          case 'InitPonctualDemoTourComponent': {
            break;
          }
          case 'PonctualBookingConclusionComponent': {
            this.overlay.instance.classCreated = this.modalParams.classCreated;
            this.overlay.instance.formation = this.modalParams.formation;
            this.overlay.instance.mode_formation = this.modalParams.mode_formation;
            break;
          }
          case 'CancelLilateComponent':
          case 'IdentityCheckComponent': {
            this.overlay.instance.lilate = this.modalParams.lilate;
            this.overlay.instance.close.subscribe(event => {
              // this.emitEvent.emit()
              this.modalParams.updateLilates.emit();
              this.close();
            });
            break;
          }
          case 'AssignExerciceComponent': {
            // Paramètres passés pour usage modal de l'assignation d'exercices
            if (this.modalParams) {
              this.overlay.instance.formationId = this.modalParams.formationId;
              this.overlay.instance.typeExercice = this.modalParams.typeExercice;
              this.overlay.instance.typeCategory = this.modalParams.typeCategory;
              this.overlay.instance.occurrenceId = this.modalParams.occurrenceId;
              this.overlay.instance.sessionUrl = this.modalParams.sessionUrl;
              this.overlay.instance.openInModal = true;
              if (this.overlay.instance.closed) {
                this.overlay.instance.closed.subscribe(() => {
                  if (!this.closedEmitted) {
                    this.closedEmitted = true;
                    this.emitEvent.emit({ component: 'AssignExerciceComponent', action: 'closed' });
                  }
                  this.close();
                });
              }
            }
            break;
          }
          default: {
            this.materialService.openSnackBar('Aucun composant à afficher dans le modal', 'red')
            return;
            break;
          }
        }

      this.show();
    }
  }

  show() {
    if (this.element) {
      document.body.appendChild(this.element);
      this.element.style.display = 'block';

      const that = this;
      // close modal on background click
      this.element.addEventListener('click', function (e: any) {
        if (e.target.className === 'modalbackground' || e.target.className === 'modalcontent') {
          that.close();
        }
      });
    }
  }

  ngOnDestroy() {
    this.close();
  }

  close() {
    if (this.element) {
      this.element.style.display = 'none';
      if (this.overlay) {
        this.overlay.destroy();
      }
      // Si on ferme autrement que par l'event interne, on notifie quand même le parent
      if (!this.closedEmitted && this.componentName === 'AssignExerciceComponent') {
        this.closedEmitted = true;
        this.emitEvent.emit({ component: 'AssignExerciceComponent', action: 'closed' });
      }
    }
  }
}
